import React, { createContext, ReactNode, useContext, useState } from "react";
import { ModalContextType, ModalConfig } from "./types";
import Modal from "./Modal";

export const ModalContext = createContext<ModalContextType>({
  closeAll: () => {
    /* init closeAll method */
  },
  closeModal: () => {
    /* init closeModal method */
  },
  openModal: () => {
    /* init openModal method */
  },
});

export const ModalProvider: React.FC<{ children: ReactNode }> = ({
  children,
}) => {
  const [modals, setModals] = useState<
    Array<{ content: JSX.Element; props?: ModalConfig }>
  >([]);

  const openModal = (children: JSX.Element, props?: ModalConfig) => {
    document
      .querySelector("html")
      ?.setAttribute("style", "overflow: hidden !important");
    setModals((prevModals) => [...prevModals, { content: children, props }]);
  };

  const closeModal = () => {
    document.querySelector("html")?.setAttribute("style", "overflow: auto");
    setModals((prevModals) => {
      const newModals = [...prevModals];
      newModals.pop();
      return newModals;
    });
  };
  const closeAll = () => {
    document.querySelector("html")?.setAttribute("style", "overflow: auto");
    setModals([]);
  };

  return (
    <ModalContext.Provider
      value={{
        openModal,
        closeModal,
        closeAll,
      }}
    >
      {children}

      {modals.map((modal, index) => (
        <Modal
          key={index}
          {...modal.props}
          open={true}
          onClose={(e) => {
            if (
              modal.props?.onPreventLeave &&
              modal.props?.shouldPreventLeave?.()
            ) {
              return modal.props.onPreventLeave();
            }
            modal.props?.onClose?.(e, "backdropClick");
            closeModal();
          }}
        >
          {modal.content}
        </Modal>
      ))}
    </ModalContext.Provider>
  );
};

export const useModal = () => {
  return useContext(ModalContext);
};
